import React, { useState } from 'react'
import { Tooltip, IconButton, Dialog } from '@material-ui/core'
import DialogView from '../../../../Dialogos/DialogView'
import EditIcon from '@material-ui/icons/Edit'
import EdicionTransferencia from './EdicionTransferencia'

function UpdateTransferencia (props) {
  const { detalle, handleUpdate } = props
  const [open, setOpen] = useState(false)

  const handleOpen = () => { setOpen(true) }
  const handleClose = () => { setOpen(false) }

  const handleSubmit = () => {
    handleUpdate()
    handleClose()
  }

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        maxWidth='lg'
      >
        <DialogView
          cancelCallback={handleClose}
          confirmCallback={handleSubmit}
          title='Edición de transferencia entre exportadores'
          content={<EdicionTransferencia detalle={detalle} />}
        />
      </Dialog>
      <Tooltip title={'Editar'}>
        <IconButton onClick={handleOpen}>
          <EditIcon />
        </IconButton>
      </Tooltip>
    </>
  )
}
export default UpdateTransferencia
